/**
 * 大模型接入管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>大模型接入管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <el-row>
      <el-col :span="10" style="margin-top: 10px;">
        <h3 id="h3_title"> 文本类</h3>
        <el-form ref="form" :model="form" label-width="140px" :rules="rules">
          <el-form-item label="model name" prop="name">
            <el-input size="small" v-model="form.model_name" placeholder="请输入"></el-input>
           <!-- <el-select size="small" v-model="form.name" placeholder="请选择" class="selectw">
              <el-option v-for="parm in fmenu" :key="parm.id" :label="parm.name" :value="parm.id"></el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item label="name" prop="name">
            <el-input size="small" v-model="form.name" placeholder="请输入"></el-input>
           <!-- <el-select size="small" v-model="form.name" placeholder="请选择" class="selectw">
              <el-option v-for="parm in fmenu" :key="parm.id" :label="parm.name" :value="parm.id"></el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item label="URL" >
            <el-input size="small" v-model="form.endpoint" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="KEY" prop="KEY">
            <el-input size="small" v-model="form.api_key" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="temperature" prop="temperature">
            <el-input size="small" v-model="form.config.temperature" placeholder="请输入0-2之间数字"></el-input>
          </el-form-item>
          <el-form-item label="max_tokens" prop="max_tokens">
            <el-input size="small" v-model="form.config.max_tokens" placeholder="请输入0-4096之间数字"></el-input>
          </el-form-item>
          <el-form-item label="top_p" prop="top_p">
            <el-input size="small" v-model="form.config.top_p" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="top_k" prop="top_k">
            <el-input size="small" v-model="form.config.top_k" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="Frequency Penalty" prop="Frequency_Penalty">
            <el-input size="small" v-model="form.config.frequency_penalty" placeholder="请输入-2.0-2之间数字"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="saveModule('form')">保存</el-button>
            <el-button size="small" type="primary" v-show="showdelete" @click="deleteModule">删除</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>

    <!-- 机器人 -->
    <ChatWidget :config="config"></ChatWidget>
  </div>
</template>

<script>
import ChatWidget from '../../components/ChatWidget'
import {
  modelInit,
  modelInitput,
  chatBOTGet
} from '../../api/userMG'
export default {
  data() {
    return {
      config:{
      title: "智能客服",
      theme: "#F68020",
      welcome: "您好，我是智能助手，有什么可以帮您解答的问题？",
      avatar: "",
      logo:'',
      position: "right",
      recommendQuestions: ["实名认证多久通过？", "SDK使用手册"],
      isNetwork: false,
      isUpload: false,
      is_show:true,
      is_online:2,
      is_show_online:false,
      contact_content: "",
      api_key:'NbR-ESy9kpU14yX23SaIrU8_hCpKSMo-LZKiQ6uRGO4',
    },
      showdelete: false,
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      form: {
        config:{
          temperature:'',
        }

      },
      // rules表单验证
      rules: {
        endpoint: [
          { required: true, message: '请输入URL', trigger: 'blur' }
        ],
        // moduleName: [
        //   { required: true, message: '请输入菜单名称', trigger: 'blur' }
        // ],
        // moduleIcon: [
        //   { required: true, message: '请输入菜单图标', trigger: 'blur' }
        // ],
        // moduleUrl: [{ required: true, message: '请输入URL', trigger: 'blur' }],
        // moduleOrder: [
        //   { required: true, message: '请输入菜单顺序', trigger: 'blur' }
        // ]
      },
      fmenu: [
          {
            name: 'DeepSeek-R1-Distill-Qwen',
            id:'1'
          },
          {
            name: 'DeepSeek-R2-Distill-Qwen',
             id:'2'
          },
      ]
    }
  },
  /**
   * 创建完毕
   */
   components: {
    ChatWidget
  },
  created() {
    this.getdata()
    this.getchats()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    getchats(){
      chatBOTGet(3)
        .then(res => {
          this.loading = false
          console.log(res,'chatBOTGetchatBOTGetchatBOTGetchatBOTGet')
          if (res.message == "success") {
              // 将十六进制颜色转换为RGB格式，便于--chat-bubble-color渲染
              this.config.theme = this.hexToRgb(res.data.theme_color);
              this.config.avatar =  res.data.icon;
              this.config.logo =  res.data.logo;
              this. config.title =  res.data.name;
              this.config.welcome =  res.data.welcome_speech;
              this.config.recommendQuestions =  res.data.recommended_question;
              if(res.data.customer_guidance=="on"){
                this.config.contact_content =  res.data.customer_guidance_text;
              }
              if(res.data.status=="normal"){
                this.config.is_show =  true;
              }
              //  this.config.api_key =  res.data.api_key;
              console.log(this.config,1111);
          } else {
            this.$message({
              type: 'info',
              message: res.detail
            })
          }
        })
        .catch(err => {
          this.loading = false
          // this.$message.error('菜单加载失败，请稍后再试！')
        })
    },
    hexToRgb(hex) {
        // 移除可能存在的 # 符号
        hex = hex.replace(/^#/, '');
        // 处理缩写形式（如 #FFF => FFFFFF）
        if (hex.length === 3) {
          hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
        }

        // 将十六进制分解为RGB分量
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);

        return `${r}, ${g}, ${b}`;
      },
       // 复选变单选
    handleClick(data, checked, node) {
      if (checked) {
        this.$refs.tree.setCheckedNodes([])
        this.$refs.tree.setCheckedNodes([data])
        this.showdelete = true
      } else {
      }
    },
    getdata(parameter) {
      this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
       modelInit(parameter)
        .then(res => {
          this.loading = false
          console.log(res,'配置获取数据成功')
          if (res.message == "success") {
            this.form = res.data;
            //name 取斜杠后面的内容
            this.form.name = res.data.name.split('/').pop();
            console.log(this.form,'配置获取数据成功')
          } else {
            this.$message({
              type: 'info',
              message: res.detail
            })
          }
        })
        .catch(err => {
          this.loading = false
          // this.$message.error('菜单加载失败，请稍后再试！')
        })
    },
    // 点击节点
    nodeclick(arr, node, self) {
      ModuleGet(arr.id)
        .then(res => {
          console.log(JSON.stringify(res))
          this.form = res.data.data
          this.$refs.tree.setCheckedNodes([])
          this.$refs.tree.setCheckedNodes([arr])
        })
        .catch(err => {
          this.loading = false
          this.$message.error('用户管理获取失败，请稍后再试！')
        })
    },
    // 保存菜单
    saveModule(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          modelInitput(JSON.stringify(this.form))
            .then(res => {
              console.log(res,'配置保存成功')
              if (res.message == "success") {
                this.$message({
                  type: 'success',
                  message: '保存成功'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.detail
                })
              }
            })
            .catch(err => {
              this.$message.error('保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 删除菜单
    deleteModule() {
      ModuleDelete(this.form.moduleId)
        .then(res => {
          this.getdata()
          this.getmenu()
          this.$message.error('菜单管理列表删除成功！')
        })
        .catch(err => {
          this.$message.error('菜单管理列表删除失败，请稍后再试！')
        })
    }
  }
}
</script>

<style>
.user-search {
  margin-top: 20px !important;
}
.user-search td {
  margin-top: 20px !important;
}
.userRole {
  width: 100%;
}
.el-table__expanded-cell {
  padding: 0px !important;
  margin: 0px !important;
}

.mod-btnbox {
  margin-bottom: 20px;
}
.treeclass {
  border: 1px solid #f3f3f3;
  padding-top: 20px;
  padding-bottom: 20px;
}
.selectw {
  width: 100%;
}
#h3_title{
  margin-left: 40px;
}
</style>




// WEBPACK FOOTER //
// src/views/largemodel/setting.vue